import {
  EyeIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  adminDeleteContact,
  getAllContactsAdmin
} from "../../slices/11-ContactUs/thunk";
import ConfirmDeleteModal from "../../component/sharedComponents/ConfirmDeleteModal";
import Pagination from "../../component/sharedComponents/Pagination";
import SectionLoader from "../../component/sharedComponents/Loading/SectionLoader";
import ContactDetailsModal from "../../component/Contact-us/ContactDetailsModal";

const SettingsContactPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { contacts, pagination, loading } = useSelector(
    (state) => state.contact
  );

  const { query } = useSelector((state) => state.search);

  const [deleteContact, setDeleteContact] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  useEffect(() => {
    dispatch(getAllContactsAdmin({ limit: 10, page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    const params = {
      page: 1,
      limit: 10,
      ...(query && { search: query }),
    };

    dispatch(getAllContactsAdmin(params));
  }, [query, dispatch]);

  const openDeleteModal = (contact) => {
    setDeleteContact(contact);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setDeleteContact(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = (contactId) => {
    dispatch(adminDeleteContact(contactId));
    closeDeleteModal();
  };

  const handlePageChange = (page) => {
    dispatch(getAllContactsAdmin({ page, limit: 10 }));
  };

  const openViewModal = (contact) => {
    setSelectedContact(contact);
    setIsViewModalOpen(true);
  };

  const closeViewModal = () => {
    setSelectedContact(null);
    setIsViewModalOpen(false);
  };

  return (
    <div className="w-full space-y-4 text-gray-900 dark:text-gray-100">

      {/* Header */}
      <h1 className="text-xl font-semibold text-black dark:text-white">
        {t("contacts.title")}
      </h1>

      <div className="relative overflow-x-auto">

        {loading ? (
          <SectionLoader />
        ) : contacts?.length === 0 ? (
          <p className="w-full text-center">{t("NotFound")}</p>
        ) : (
          <>
            <table className="min-w-full text-sm text-left border rounded-xl dark:border-border-dark border-border-light">
              <thead className="text-xs uppercase dark:bg-bg-dark-secondary bg-bg-light-secondary">
                <tr className="text-center">
                  <th className="px-4 py-3">#</th>
                  <th className="px-4 py-3">{t("contacts.fullName")}</th>
                  <th className="px-4 py-3">{t("contacts.email")}</th>
                  <th className="px-4 py-3">{t("contacts.phone")}</th>
                  <th className="px-4 py-3">{t("contacts.message")}</th>
                  <th className="px-4 py-3">{t("contacts.date")}</th>
                  <th className="px-4 py-3">{t("contacts.actions")}</th>
                </tr>
              </thead>

              <tbody className="dark:bg-bg-dark-secondary bg-bg-light-secondary">
                {contacts?.map((contact, index) => (
                  <tr
                    key={contact?.id}
                    className="text-center hover:bg-bg-light-primary dark:hover:bg-bg-dark-primary"
                  >
                    <td className="px-2 py-3">{index + 1}</td>
                    <td className="px-2">{contact?.full_name}</td>
                    <td className="px-2">{contact?.email}</td>
                    <td className="px-2">{contact?.phone}</td>
                    <td className="max-w-xs px-2">
                      {contact?.additional_notes?.length > 10 ? (
                        <>
                          {contact?.additional_notes?.slice(0, 10)}...
                          <span className="block text-xs text-gray-400">
                          </span>
                        </>
                      ) : (
                        <>
                          {contact?.additional_notes}
                          <span className="block text-xs text-gray-400">
                          </span>
                        </>
                      )}
                    </td>
                    <td className="px-2">
                      {new Date(contact?.createdAt).toLocaleDateString()}
                    </td>
                    <td className="px-2">
                      <div className="flex items-center justify-center gap-3">
                        <button onClick={() => openViewModal(contact)}
                          title={t("contacts.view")}
                        >
                          <EyeIcon className="w-5 h-5 text-yellow-400" />
                        </button>

                        <button onClick={() => openDeleteModal(contact)}
                          title={t("contacts.delete")}
                        >
                          <TrashIcon className="w-5 h-5 text-red-500" />
                        </button>

                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {pagination && contacts?.length > 0 && (
              <Pagination
                pagination={pagination}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}

        {selectedContact && (
          <ContactDetailsModal
            isOpen={isViewModalOpen}
            onClose={closeViewModal}
            contact={selectedContact}
          />
        )}

        {deleteContact && (
          <ConfirmDeleteModal
            isOpen={isDeleteModalOpen}
            onClose={closeDeleteModal}
            onConfirm={confirmDelete}
            post={deleteContact}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsContactPage;